import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWave"><Path d="M2 12H7V3.5H12V20.5H17V11.5H22" stroke="currentColor"/></CentralIconBase>;
});

export default IconWave;
